
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favorite",
      function () {
        return require("private-next-pages/favorite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/favorite"])
      });
    }
  